/**
 * Equipment Item Level ↔ Class Level requirements (M7-D2).
 *
 * requiredClassLevel = min(60, max(1, itemLevel - 5))
 * Derived at use-time — do not store a redundant field on every item.
 */

import { CLASS_LEVEL_CAP } from '../persistence/schema';
import { ITEM_LEVEL_SYSTEM_RANGE, clampItemLevel } from './dungeonProgression';

/**
 * Minimum class level required to equip an item of the given item level.
 * Missing / invalid item levels are treated as 1 (requirement CL 1).
 */
export function requiredClassLevelForItemLevel(itemLevel: number | undefined | null): number {
  const ilvl =
    typeof itemLevel === 'number' && Number.isFinite(itemLevel)
      ? clampItemLevel(itemLevel, ITEM_LEVEL_SYSTEM_RANGE.max)
      : ITEM_LEVEL_SYSTEM_RANGE.min;
  return Math.min(
    CLASS_LEVEL_CAP,
    Math.max(1, Math.floor(ilvl) - 5),
  );
}

export function meetsItemLevelClassRequirement(
  classLevel: number,
  itemLevel: number | undefined | null,
): boolean {
  const cl = Math.max(1, Math.floor(classLevel));
  return cl >= requiredClassLevelForItemLevel(itemLevel);
}
